import type { AliasableExpression } from 'kysely'
import type { InputSortDirection, SortDirection } from './queryHelpers'

export function asNotNull<T>(expr: AliasableExpression<T>) {
  return expr as unknown as AliasableExpression<Exclude<T, null>>
}

export function normalizeSortDirection(direction?: InputSortDirection | null): SortDirection {
  if (direction === 'ascend' || direction === 'asc') return 'asc'
  if (direction === 'descend' || direction === 'desc') return 'desc'
  return 'asc'
}
